import React from 'react';
import { TFunction } from 'i18next';
import { IAppFeature } from '../../../../types/interfaces/app-feature';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import AppSwitch from '../../../../components/designe/app-switch/AppSwitch';

export function getCellReducers(
  t: TFunction,
  classes: any,
  canEdit: boolean,
  onEdit: (feature: IAppFeature, e: any) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.TITLE,
      cellReducer: (feature: IAppFeature) => {
        return <div className={classes.title}>{feature.title}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.KEY,
      cellReducer: (feature: IAppFeature) => {
        return <div className={classes.key}>{feature.key}</div>;
      },
    },

    {
      id: TABLE_COLUMNS_IDS.IS_ACTIVE,
      cellReducer: (feature: IAppFeature) => {
        return (
          <div className={classes.isPrivate}>
            <AppSwitch
              disabled={!canEdit}
              value={feature.isActive}
              checked={feature.isActive}
              onChange={(e) => onEdit(feature, e.target.checked)}
            />
          </div>
        );
      },
    },
  ];
}
